import {UserController_GetPendingActionsResponse} from "../../../api/api.service";


export interface IPendingActionExternalLinkHandler<TOptions> {
    openPendingAction(options?: TOptions): Promise<PendingActionResultEnum>;
}

export type PendingActionData = UserController_GetPendingActionsResponse["PendingActions"][number];

export enum PendingActionResultEnum {
    ContinueCurrentFlow,
    BlockCurrentFlow
}

export enum PendingActionTypeEnum {
    ResponsibleGaming = 19,
    ResponsibleGamingPhase2 = 22,

    /*
    Register player to regulator = 1,
    Demo to Real conversion = 2,
    Privacy policy = 3,
    Terms and Conditions approval = 4,
    Spain Full Migration = 5,
    Spain Only Migration = 6,
    Spain Only Registartion = 7,
    Complete Registration = 8,
    OPT-IN (whether the user wants Promotion Emails ) = 9,
    Geo Locate Mobile = 10,
    Players acknowledges before continuing = 11,
    Email Verification = 13,
    NEM-ID authentication required = 14,
    Sweden migration = 15,
    UK DOB Verification = 16,
    UK Address Verification = 17,
    UK View Verification Page = 18,
    Responsible Gaming = 19,
    Bonus Policy change = 20,
    Hesse Terms and Conditions Approval = 21,
    Responsible Gaming Phase 2 = 22,
    Retry Page = 23,
    Adding playing time limits = 24,
    ResubscribePending = 28,
    */
}

export enum PendingActionReasonEnum {
    GamingCautionInteraction = 20,
    /*
    Complete real registration process = 1,
    Time out in registration to regulator = 2,
    Regulation Migration Process = 3,
    Short Registration Process = 4,
    Geo Location Detection = 5,
    Deposited more than the limit = 6,
    ThePlayerShouldVerifyHisEmailBeforeContinuing = 7,
    Terms and Conditions update = 8,
    Other = 9,
    DE Migration Process = 10,
    Danish Player should be authenticated with its NEM-ID = 11,
    UK account verification = 12,
    Gaming Caution escalation = 14,
    Adding playing time limits = 16,
    Adding playing time limits = 17,
    */
}

export enum PendingActionIdEnum {
    SwedenGamingCaution = 40
}